import { createConfig } from '@streaming/mouflon-utils';

import { TEventBus } from '@eventBus/EventBus';

import { defaultConfig, IDoppioPlayerConfig } from '../config';

export const { ConfigConsumer: _ConfigConsumer, setConfig } = createConfig(defaultConfig);

export class ConfigConsumer<TConfigCurrent extends IDoppioPlayerConfig[keyof IDoppioPlayerConfig]> extends _ConfigConsumer<
  IDoppioPlayerConfig,
  TConfigCurrent,
  TEventBus
> {}
